import { render } from "./OverallStatistics.vue?vue&type=template&id=f4d42c80&scoped=true"
import script from "./OverallStatistics.vue?vue&type=script&lang=js"
export * from "./OverallStatistics.vue?vue&type=script&lang=js"

import "./OverallStatistics.vue?vue&type=style&index=0&id=f4d42c80&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4d42c80"]])

export default __exports__